import React from 'react';
import Surface from './ui/Surface';
import styles from './ComingSoon.module.css';

const ComingSoon = ({ title, description }) => {
  return (
    <div className={styles.wrapper}>
      <Surface tone="glass" padding="lg" className={styles.surface}>
        <span className={styles.pill}>Work in progress</span>
        <h2>{title}</h2>
        <p>{description}</p>
      </Surface>
    </div>
  );
};

export default ComingSoon;
